/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Danish
export default {
    'fabric.atlassianSwitcher.switchTo': 'Skift til',
    'fabric.atlassianSwitcher.switchToTooltip': 'Skift til…',
    'fabric.atlassianSwitcher.recent': 'Seneste',
    'fabric.atlassianSwitcher.more': 'Mere',
    'fabric.atlassianSwitcher.try': 'Prøv',
    'fabric.atlassianSwitcher.manageList': 'Administrér liste',
    'fabric.atlassianSwitcher.jiraProject': 'Jira-projekt',
    'fabric.atlassianSwitcher.confluenceSpace': 'Confluence-område',
    'fabric.atlassianSwitcher.people': 'Personer',
    'fabric.atlassianSwitcher.administration': 'Administration',
    'fabric.atlassianSwitcher.discoverMore': 'Se flere',
    'fabric.atlassianSwitcher.errorHeading': 'Der gik noget galt',
    'fabric.atlassianSwitcher.errorText': 'Vi registrerer disse fejl, men du er velkommen til at kontakte os, hvis problemet ikke løses, når du genindlæser',
    'fabric.atlassianSwitcher.errorImageAltText': 'En ødelagt robot og en flok mennesker er i gang med at ordne det.',
    'fabric.atlassianSwitcher.expand': 'Udvid',
};
//# sourceMappingURL=da.js.map